import React, { createContext, useContext } from 'react';
import { getColors, type Colors } from '@ai-content-hub/shared-styles';

/**
 * `packages/ui` composites (`ActionButtons`, `DataTable`, ...) need theme
 * colors but cannot depend on any app's Redux/localStorage-backed theme
 * provider (Tier 1 must not depend on Tier 2/3). This context is the seam:
 * the app's real `ThemeProvider` feeds its resolved `Colors` in here once;
 * with no provider mounted, it falls back to the light palette from
 * `@ai-content-hub/shared-styles` — never a hardcoded hex value.
 */
const UIColorsContext = createContext<Colors>(getColors(false));
UIColorsContext.displayName = 'UIColorsContext';

export interface UIColorsProviderProps {
    colors: Colors;
    children: React.ReactNode;
}

export const UIColorsProvider: React.FC<UIColorsProviderProps> = ({ colors, children }) => (
    <UIColorsContext.Provider value={colors}>{children}</UIColorsContext.Provider>
);

export function useUIColors(): Colors {
    return useContext(UIColorsContext);
}
